import { useEffect, useState } from 'react';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Card from './Card';

const useStyles = makeStyles(({ breakpoints: BP }) => ({
  container: {
    margin: '50px 10%',
    display: 'flex',
    [BP.between('xs', 'md')]: {
      flexDirection: 'column-reverse',
      margin: '35px 5%',
    },
  },
  card: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginRight: 20,
    borderRadius: 10,
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    backgroundColor: '#fff',
    color: '#283142',
    boxSizing: 'border-box',
    padding: '30px 40px',
    [BP.between('xs', 'md')]: {
      padding: '7%',
      margin: '0 0 20px',
    },
  },

  header: {
    display: 'flex',
    flexDirection: 'column',
    color: '#283142',
    '& h1': {
      fontSize: 30,
      margin: '0 0 20px',
    },
    '& h3': {
      fontSize: 15,
      fontWeight: 300,
      lineHeight: 1.4,
      margin: 0,
    },
    [BP.between('xs', 'md')]: {
      alignItems: 'center',
    },
  },
  flex: {
    flex: 1,
    marginLeft: 20,
    [BP.between('xs', 'md')]: {
      marginLeft: 0,
    },
  },
  img: {
    height: 290,
    objectFit: 'contain',
    alignSelf: 'center',
    marginTop: 20,
    [BP.between('xs', 'md')]: {
      height: '33vh',
    },
  },
}));

const parseCatData = (arr = []) =>
  arr.map((i) => ({
    id: i.id,
    title: i.title,
    img: _get(i, 'image.url', null),
  }));

export default function Cats({ CatList = [] }) {
  const cls = useStyles();
  const [DATA, setData] = useState([]);

  useEffect(() => {
    setData(parseCatData(CatList));
  }, [CatList]);

  return (
    <section className={cls.container}>
      <Grid container spacing={2} className={cls.flex}>
        {DATA.slice(0, 12).map((i, idx) => (
          <Card item={i} key={idx} />
        ))}
      </Grid>
      <div className={cls.card}>
        <div className={cls.header}>
          <h1>دسته بندی اصلی</h1>
          <h3>
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
            استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
            ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد
          </h3>
        </div>
        <img src="/images/home/sofa.png" className={cls.img} alt="cat" />
      </div>
    </section>
  );
}
